import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-body d-flex flex-column" }
const _hoisted_4 = { class: "text-subtitle" }
const _hoisted_5 = {
  class: "text-paragraph",
  style: {"white-space":"normal !important"}
}
const _hoisted_6 = { class: "d-flex align-items-center justify-content-between mt-auto" }
const _hoisted_7 = { class: "text-paragraph mb-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-5" }, null, -1)
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "text-subtitle mb-2" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "text-label text-primary50 mb-0 me-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right text-primary ms-auto fa-lg" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!
  const _component_Profile = _resolveComponent("Profile")!
  const _component_ScrollHorizontal = _resolveComponent("ScrollHorizontal")!
  const _component_Section = _resolveComponent("Section")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_Profile, {
            user: _ctx.patient?.user,
            chat: _ctx.patient?.chat
          }, null, 8, ["user", "chat"]),
          (_ctx.patient.recurrencies && _ctx.patient.recurrencies.length)
            ? (_openBlock(), _createBlock(_component_Section, {
                key: 0,
                title: "Recorrências",
                icon: "fa-solid fa-arrow-rotate-left",
                hasBorder: false
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ScrollHorizontal, {
                    items: _ctx.patient.recurrencies
                  }, {
                    default: _withCtx(({ item }) => [
                      _createElementVNode("div", {
                        onClick: ($event: any) => (_ctx.handleRecurrency(item.id)),
                        class: "card rounded-4 cursor-pointer",
                        style: {"max-width":"220px","min-height":"200px"}
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createElementVNode("p", _hoisted_4, _toDisplayString(item?.title), 1),
                          _createElementVNode("p", _hoisted_5, _toDisplayString(item?.description), 1),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("p", _hoisted_7, _toDisplayString(item?.value), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass(["badge", item?.status_bg_color])
                            }, _toDisplayString(item?.status_label), 3)
                          ])
                        ])
                      ], 8, _hoisted_2)
                    ]),
                    _: 1
                  }, 8, ["items"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _hoisted_8,
          _createVNode(_component_Section, {
            title: "Sessões",
            icon: "fa-regular fa-calendar-days",
            hasBorder: false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.patient.appointments, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "d-flex py-4 border-bottom align-items-center cursor-pointer",
                  onClick: ($event: any) => (_ctx.handleAppointment(item.id)),
                  key: index
                }, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(item.formatted_datetime), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, " R$" + _toDisplayString(item.value), 1),
                      _createElementVNode("p", {
                        class: _normalizeClass(["text-label mb-0", item.status_color])
                      }, _toDisplayString(item.status_label), 3)
                    ])
                  ]),
                  _hoisted_13
                ], 8, _hoisted_9))
              }), 128))
            ]),
            _: 1
          })
        ], 64))
  ]))
}